import { Area } from 'react-easy-crop';

export const WEBP_QUALITY = 0.8;

export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', reject);
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = src;
  });
}

export function getImageDimensions(file: File): Promise<{ width: number; height: number }> {
  const url = URL.createObjectURL(file);

  return loadImage(url).then((image) => {
    const dimensions = { width: image.naturalWidth, height: image.naturalHeight };

    URL.revokeObjectURL(url);

    return dimensions;
  });
}

export function matchesTargetRatio(width: number, height: number, targetWidth: number, targetHeight: number) {
  const ratio = width / height;
  const targetRatio = targetWidth / targetHeight;

  return Math.abs(ratio - targetRatio) < 0.01;
}

export async function getCroppedWebpFile(
  imageSrc: string,
  cropPixels: Area,
  targetWidth: number,
  targetHeight: number,
  fileName: string,
): Promise<File> {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');

  canvas.width = targetWidth;
  canvas.height = targetHeight;

  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('Canvas context is not available');
  }

  context.drawImage(
    image,
    cropPixels.x,
    cropPixels.y,
    cropPixels.width,
    cropPixels.height,
    0,
    0,
    canvas.width,
    canvas.height,
  );

  const blob = await new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, 'image/webp', WEBP_QUALITY);
  });

  if (!blob) {
    throw new Error('Image encoding failed');
  }

  const baseName = fileName.replace(/\.[^/.]+$/, '');

  return new File([blob], `${baseName}.webp`, { type: 'image/webp' });
}
